<div class="login-page">
  <div class="login-page__card">
    <div class="login-page__logo" aria-label="ECAM EventQ">
      <img
        class="login-page__logo-image"
        src="assets/login/ecam-eventq-logo.svg"
        alt="Event Q powered by ECAM"
      />
    </div>

    <p class="login-page__lead">Sign in to continue to EventQ</p>

    @if (credentialLoginEnabled()) {
      <form class="login-page__form" (submit)="onSubmit($event)">
        <div class="login-page__fields">
          <div class="login-page__field">
            <eventq-input
              type="email"
              label="Email"
              placeholder="user@ecam.com"
              [validateRequired]="false"
              [validateEmail]="false"
              [submitAttempted]="submitAttempted()"
              [value]="email()"
              [disabled]="submitting()"
              (valueChange)="setEmail($event)"
            />
            @if (emailError(); as message) {
              <p class="login-page__field-error" role="alert">{{ message }}</p>
            }
          </div>
          <div class="login-page__field">
            <eventq-input
              type="password"
              label="Password"
              placeholder="Password"
              [showPasswordToggle]="true"
              [validateRequired]="false"
              [submitAttempted]="submitAttempted()"
              [value]="password()"
              [disabled]="submitting()"
              (valueChange)="setPassword($event)"
            />
            @if (passwordError(); as message) {
              <p class="login-page__field-error" role="alert">{{ message }}</p>
            }
          </div>
        </div>

        @if (sessionDefaultsError()) {
          <p class="login-page__status" role="status">{{ sessionDefaultsError() }}</p>
        }

        @if (loginError()) {
          <p class="login-page__error" role="alert">{{ loginError() }}</p>
        }

        <eventq-button
          class="login-page__submit"
          label="Login"
          variant="primary-solid"
          size="lg"
          type="submit"
          [disabled]="submitting()"
          [attr.aria-busy]="submitting()"
          (pressed)="onLogin()"
        />
      </form>

      <p class="login-page__divider">OR</p>
    }

    @if (oktaUnavailableMessage()) {
      <p class="login-page__status" role="status">{{ oktaUnavailableMessage() }}</p>
    }

    <eventq-button
      class="login-page__okta"
      label="Login with OKTA"
      variant="ghost-okta"
      size="lg"
      iconSrc="assets/login/okta-logo.svg"
      (pressed)="onOktaLogin()"
    />
  </div>
</div>
